import React, { ReactNode } from 'react'

interface IMessageProps {
  children: ReactNode
}

export const Message = (props: IMessageProps) => {
  return <p className="ly-alert__msg">{props.children}</p>
}
